import { makeStyles } from '@material-ui/core/styles'

export const wikiDocumentStyle = makeStyles(theme => ({
  backButton: {
    color: theme.palette.geoColors.headerText.main
  },
  backButtonIcon: {
    color: theme.palette.geoColors.headerText.main
  },
  backButtonPadding: {
    paddingLeft: theme.spacing(1)
  },
  content: {
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    '& p': {
      margin: 0
    }
  },
  headerTitle: {
    maxWidth: '70%',
    alignSelf: 'center',
    lineHeight: '1rem',
    maxHeight: '1rem',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    userSelect: 'none'
  },
  footer: {
    paddingTop: theme.spacing(6),
    marginBottom: theme.spacing(2),
    fontSize: '0.7rem',
    fontStyle: 'italic'
  },
  nestedListSubheader: {
    display: 'flex',
    flexDirection: 'row',
    minHeight: '48px',
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.geoColors.headerText.main,
    userSelect: 'none'
  },
  progress: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-around',
    paddingTop: theme.spacing(2),
    fontSize: '0.8rem',
    color: theme.palette.geoColors.text.light
  },
  resume: {
    paddingTop: theme.spacing(1),
    fontSize: '0.8rem'
  },
  title: {
    paddingTop: theme.spacing(2),
    fontSize: '1.2rem',
    fontWeight: 'bold'
  },
  logo: {
    maxWidth: '50%'
  }
}))
